import { resolveComponent as t, openBlock as e, createElementBlock as n, createVNode as r } from "vue";
import { _ as s } from "./_plugin-vue_export-helper-dad06003.js";
import { X as c } from "./XIcon-e21df3cc.js";
const a = {
  components: {
    XIcon: c
  }
}, p = {
  type: "button",
  class: "rounded-lg p-2 bg-transparent ct-bg-1--hover focus:ct-ring-focus--shadow focus:outline-none"
};
function m(u, _, d, i, f, l) {
  const o = t("XIcon");
  return e(), n("button", p, [
    r(o, {
      class: "h-4 sm:h-5 w-4 sm:w-5 text-gray-400 dark:text-neutral-500 ct-bg-1--hover",
      "aria-hidden": "true"
    })
  ]);
}
const x = /* @__PURE__ */ s(a, [["render", m]]);
export {
  x as B
};
